// src/lib/onboarding-navigation-utils.ts

/**
 * Determines the appropriate page to redirect users to based on their onboarding progress
 * when they don't have data available in analysis pages.
 */
export const getOnboardingRedirectPath = (
  webAppUrl: string | null,
  hasData: boolean,
): { path: string; message: string } => {
  // If no Web App URL, they haven't completed the setup process yet
  if (!webAppUrl) {
    return {
      path: "/onboarding/start",
      message:
        "Please complete the setup process first by copying the Google Sheets template and deploying the script.",
    };
  }

  // If they have Web App URL but no data (rare case), send to analysis page
  if (webAppUrl && !hasData) {
    return {
      path: "/onboarding/analysis",
      message:
        "Your setup is complete, but data hasn't loaded yet. Please go to the Analysis page to fetch your account data.",
    };
  }

  // If they have Web App URL and have progressed, send to results page
  return {
    path: "/onboarding/results",
    message: "Please return to choose your analysis path.",
  };
};
